module.exports = __webpack_public_path__ + "img/bgc.3789b233.png";